import { useCallback, useState } from 'react'
import { acknowledgeHelpdeskRequest } from '@/lib/services/helpdeskService'

export function useAcknowledgeRequest(onLocalAcknowledge: (id: string) => void) {
  const [loadingId, setLoadingId] = useState<string | null>(null)

  const acknowledge = useCallback(
    async (id: string) => {
      setLoadingId(id)
      try {
        onLocalAcknowledge(id)
        await acknowledgeHelpdeskRequest(id)
      } finally {
        setLoadingId(null)
      }
    },
    [onLocalAcknowledge],
  )

  return { acknowledge, loadingId }
}